import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/feature/VideoCard';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { allVideos } from '@/mocks/videos';
import { articles } from '@/mocks/articles';

export default function Home() {
  const brandCategories = categories.slice(1, 5);
  const hotVideos = [...allVideos].sort((a, b) => b.views - a.views).slice(0, 8);
  const latestVideos = [...allVideos].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()).slice(0, 8);
  const featuredArticles = articles.slice(0, 4);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20dramatic%20red%20and%20gold%20lighting%20abstract%20film%20reel%20graphics%20projection%20light%20beams%20cutting%20through%20darkness%20premium%20home%20cinema%20experience%20modern%20elegant%20dark%20ambiance%20rich%20deep%20black%20red%20gold%20tones&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
            alt="51视频 - 蓝光4K超清免费在线观看"
            className="absolute inset-0 w-full h-full object-cover"
            title="51视频 - 蓝光4K超清无广告免费在线观看"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/80"></div>
          <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold font-heading text-foreground-50 mb-4 leading-tight">
              蓝光<span className="text-accent-500">4K</span>超清
              <br className="md:hidden" />
              无广告不缓冲
            </h1>
            <p className="text-base md:text-lg text-foreground-300 mb-8 max-w-2xl mx-auto leading-relaxed">
              51视频汇集蓝莓视频、糖心视频、黑桃视频、妖精视频等品牌高清资源，
              蓝光4K超清画质，播放流畅不缓冲，免费在线观看
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-950 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观看
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-background-100/60 hover:bg-background-100/80 text-foreground-200 rounded-full text-base font-medium backdrop-blur-sm border border-background-200/50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center justify-center gap-6 md:gap-10 mt-10">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">10万+</div>
                <div className="text-xs text-foreground-400 mt-1">高清资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">蓝光4K</div>
                <div className="text-xs text-foreground-400 mt-1">顶级画质</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">0广告</div>
                <div className="text-xs text-foreground-400 mt-1">纯净观影</div>
              </div>
            </div>
          </div>
        </section>

        {/* Brand Categories */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-100 mb-3">
                品牌专区
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                四大品牌频道，满足您的不同观影需求
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {brandCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative rounded-xl overflow-hidden aspect-[4/3] bg-background-100 cursor-pointer"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary-500/20 via-transparent to-accent-500/20 group-hover:opacity-80 transition-opacity"></div>
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-950/30 backdrop-blur-sm mb-3 group-hover:scale-110 transition-transform duration-300">
                      <i className={`${cat.icon} text-2xl md:text-3xl text-accent-500`}></i>
                    </div>
                    <h3 className="text-base md:text-lg font-bold font-heading text-foreground-50 mb-1">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-400 group-hover:text-accent-500 transition-colors">
                      立即观看 <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-100 mb-1">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500">全网最受欢迎的高清视频资源</p>
              </div>
              <Link
                to="/category/all"
                className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
              {hotVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Videos */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-100 mb-1">
                  <i className="ri-time-line text-accent-500 mr-2"></i>
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500">每日更新，精彩不断</p>
              </div>
              <Link
                to="/category/all"
                className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
              {latestVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/50">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4">
                  <i className="ri-4k-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">蓝光4K超清</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  真4K片源，HDR高动态范围，每一帧都如壁纸般细腻。支持杜比视界，带来影院级视觉享受。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/50">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4">
                  <i className="ri-forbid-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">零广告干扰</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  全程无广告插入，片头片尾不加水印。纯净的观影体验，让您沉浸其中不受打扰。
                </p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/50">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 mb-4">
                  <i className="ri-speed-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">流畅不缓冲</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  自研P2P-CDN加速技术，全国数千节点覆盖。智能码率调节，网络波动时自动优化。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Articles */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-100 mb-1">
                  <i className="ri-article-line text-accent-500 mr-2"></i>
                  精选文章
                </h2>
                <p className="text-sm text-foreground-500">观影指南、技术科普、行业资讯</p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="relative px-4 md:px-6 py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20flowing%20golden%20and%20warm%20amber%20light%20streaks%20dark%20elegant%20atmosphere%20premium%20movie%20theater%20feeling%20smooth%20gradient%20curves%20luxurious%20modern%20design&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-background-950/75"></div>
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-4">
              准备好享受顶级观影体验了吗？
            </h2>
            <p className="text-sm md:text-base text-foreground-300 mb-8 leading-relaxed">
              海量蓝光4K超清资源，零广告纯净观影，流畅播放不缓冲。立即加入我们，开启您的视觉盛宴。
            </p>
            <Link
              to="/category/all"
              className="inline-flex px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-950 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2 text-lg"></i>
              免费观看
            </Link>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '51视频',
            url: 'https://51video.com/',
            description: '51视频提供蓝莓视频、糖心视频、黑桃视频、妖精视频等高清画质资源，蓝光4K超清无广告，播放流畅不缓冲，免费在线观看。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://51video.com/category/all?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '51视频',
            url: 'https://51video.com/',
            description: '51视频 - 蓝光4K超清无广告不缓冲免费在线观看平台',
            sameAs: [],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '51视频 | 蓝光4K超清无广告不缓冲免费高清在线观看',
            description: '51视频提供蓝莓视频、糖心视频、黑桃视频、妖精视频等高清画质资源，蓝光4K超清无广告，播放流畅不缓冲，免费在线观看。',
            url: 'https://51video.com/',
            isPartOf: { '@type': 'WebSite', name: '51视频', url: 'https://51video.com/' },
          }),
        }}
      />
    </>
  );
}